// extracted by mini-css-extract-plugin
export default {"selectProjectWrapper":"_1d6a86b9"};